module.exports = __webpack_public_path__ + "media/images/formbeat-logo-fbf3c2f3.svg";